import { useState } from 'react'
import type { FormEvent } from 'react'
import { Link } from 'react-router'
import { ApiError } from '../../lib/api.js'
import { useAuth } from '../../lib/auth.js'
import { Button, Input } from '../../ui/index.js'
import { usePageTitle } from '../../lib/page-title.js'
import { AuthLayout } from './AuthLayout.js'
import { FieldError } from './FormError.js'


export function ForgotPassword() {
  usePageTitle('Forgot password')
  const { api } = useAuth()
  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState<Record<string, string>>({})
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    const next: Record<string, string> = {}
    if (email.trim() === '') next['email'] = 'Enter your email address'
    setErrors(next)
    if (Object.keys(next).length > 0) return

    setBusy(true)
    try {
      await api.post('/api/auth/forgot-password', { email: email.trim() })
    } catch (error) {
      if (!(error instanceof ApiError)) {
        // Ignore network failures too: the confirmation must be the same regardless.
      }
    } finally {
      setBusy(false)
      setDone(true)
    }
  }

  if (done) {
    return (
      <AuthLayout title="Reset your password" footer={<Link to="/login">← Back to sign in</Link>}>
        <div
          role="status"
          style={{
            background: 'var(--positive-bg)',
            color: 'var(--positive)',
            borderRadius: 12,
            padding: '14px 16px',
            display: 'flex',
            gap: 10,
            alignItems: 'flex-start',
            fontSize: 13,
            lineHeight: 1.5,
          }}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" style={{ flexShrink: 0, marginTop: 1 }}>
            <path d="M3 8.5l3.2 3.2L13 5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span>Reset link sent to {email.trim()}. Check your inbox.</span>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout title="Reset your password" subtitle="Enter your work email and we'll send a reset link.">
      <form onSubmit={submit} noValidate>
        <div className="field" style={{ marginBottom: 'var(--o-space-5)' }}>
          <label className="field-label" htmlFor="email">
            Work email
          </label>
          <Input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={setEmail}
          />
          <FieldError message={errors['email']} />
        </div>
        <Button type="submit" kind="primary" disabled={busy} style={{ width: '100%' }}>
          Send reset link
        </Button>
      </form>
    </AuthLayout>
  )
}
